<template>
  <el-form label-width="120px" ref="eleBillForm" :rules="eleBillFormRule" :model="eleBillForm" class="step4CnCom">
    <div class="cainiao pddTab">
      <el-tabs :stretch="true" class="taobao" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="淘宝店铺账号授权" name="shop">
          <template v-if="activeName == 'shop'">
            <div class="tab-header">
              <div class="left-c">
                <img src="@/assets/images/ecommercepng/icon_dianpu_TAOBAO.png" class="icon-company-box" alt="">
              </div>
            </div>
            <div class="tab-bottom" v-if="tbShopList.length > 0 || (tbShopList.length <= 0 && loading)">
              <el-form-item label="淘宝店铺" prop="shop" >
                <div class="y-f">
                  <el-select v-model="eleBillForm.shop" placeholder="请选择店铺类型" @change="changeShop">
                    <el-option v-for="item in tbShopList" :key="item.id" :label="item.MallName" :value="item.id">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="storeAuthorization('TAOBAO')">添加新店铺</span>
                </div>
              </el-form-item>
              <el-form-item label="网点发货地址" prop="faceId">
                <div class="y-f" v-if="filterOriginList.length > 0 || (filterOriginList.length <= 0 && loading)">
                  <el-select @change="changeAddress" v-model="eleBillForm.faceId" placeholder="请选择发货地址">
                    <el-option v-for="item in filterOriginList" :key="item.id" :label="item.addressInfo" :value="item.id">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="jumpTb">添加新发货地址</span>
                </div>
                <div class="y-bk-fff6a0" style="padding: 5px" v-else>
                  <p class="y-fl-18" style="margin: 0">未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。</p>
                </div>
              </el-form-item>
              <div v-if="filterOriginList.length <= 0 && !loading" class="y-fc-4C84FF y-c-p y-f-r y-fs-14">
                <span @click="jumpTb">开通电子面单</span>
                <span @click="storeAuthorization('TAOBAO')" class="y-ml-10">绑定电子面单账号</span>
                <span @click="howHelpAuth('TAOBAO')" class="y-ml-10">查看教程</span>
              </div>
            </div>
            <div v-else class="tab-bottom y-fs-14 clearfix">
              <p class="y-fc-000 y-fl-18">
                您还未绑定任何淘宝店铺，请点击&lt;去绑定&gt;绑定您的淘宝店铺，或点击&lt;查看教程&gt;，按步骤进行操作。
              </p>
              <div class="y-fc-4C84FF y-c-p y-f-r">
                <span @click="storeAuthorization('TAOBAO')">去绑定</span>
                <span @click="howHelpAuth('TAOBAO')" class="y-ml-10">查看教程</span>
              </div>
            </div>
          </template>
        </el-tab-pane>

         <el-tab-pane label="1688账号授权" name="ali_1688">
          <template v-if="activeName == 'ali_1688'">
            <div class="tab-header">
              <div class="left-c">
                <img src="@/assets/images/ecommercepng/icon_dianpu_ALI_1688.png" class="icon-company-box" alt="">
              </div>
            </div>
            <div class="tab-bottom" v-if="Object.keys(aliShopObj).length > 0 || (Object.keys(aliShopObj).length <= 0 && loading)">
              <el-form-item label="1688账号" prop="shop" >
                <div class="y-f">
                  <el-select v-model="eleBillForm.shop" placeholder="请选择账号" @change="changeShop">
                    <el-option v-for="(val, key) in aliShopObj" :key="key" :label="val" :value="key">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="storeAuthorization('ALI_1688')">添加新账号</span>
                </div>
              </el-form-item>
              <el-form-item label="网点发货地址" prop="faceId">
                <div class="y-f" v-if="filterOriginList.length > 0 || (filterOriginList.length <= 0 && loading)">
                  <el-select @change="changeAddress" v-model="eleBillForm.faceId" placeholder="请选择发货地址">
                    <el-option v-for="item in filterOriginList" :key="item.id" :label="item.addressInfo" :value="item.id">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="jumpTb">添加新发货地址</span>
                </div>
                <div class="y-bk-fff6a0" style="padding: 5px" v-else>
                  <p class="y-fl-18" style="margin: 0">未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。</p>
                </div>
              </el-form-item>
              <div v-if="filterOriginList.length <= 0 && !loading" class="y-fc-4C84FF y-c-p y-f-r y-fs-14">
                <span @click="jumpTb">开通电子面单</span>
                <span @click="storeAuthorization('ALI_1688')" class="y-ml-10">绑定电子面单账号</span>
                <span @click="howHelpAuth('ALI_1688')" class="y-ml-10">查看教程</span>
              </div>
            </div>
            <div v-else class="tab-bottom y-fs-14 clearfix">
              <p class="y-fc-000 y-fl-18">
                您还未绑定任何1688账号，请点击&lt;去绑定&gt;绑定您的1688账号，或点击&lt;查看教程&gt;，按步骤进行操作。
              </p>
              <div class="y-fc-4C84FF y-c-p y-f-r">
                <span @click="storeAuthorization('ALI_1688')">去绑定</span>
                <span @click="howHelpAuth('ALI_1688')" class="y-ml-10">查看教程</span>
              </div>
            </div>
          </template>
        </el-tab-pane>

        <el-tab-pane label="菜鸟账号授权" name="username">
          <template v-if="activeName == 'username'">
            <div class="tab-header">
              <div class="left-c">
                <img src="@/assets/images/ecommercepng/icon_cainiao.png" class="icon-company-box" alt="">
              </div>
            </div>
            <div class="tab-bottom" v-if="Object.keys(cnShopObj).length > 0 || (Object.keys(cnShopObj).length <= 0 && loading)">
              <el-form-item label="菜鸟账号" prop="shop">
                <div class="y-f">
                  <el-select v-model="eleBillForm.shop" placeholder="请选择账号" @change="changeShop">
                    <el-option v-for="(val, key) in cnShopObj" :key="key" :label="val" :value="key">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="getCNAccessToken">添加新账号</span>
                </div>
              </el-form-item>
              <el-form-item label="网点发货地址" prop="faceId">
                <div class="y-f" v-if="filterOriginList.length > 0 || loading">
                  <el-select
                    @change="changeAddress"
                    v-model="eleBillForm.faceId"
                    placeholder="请选择发货地址">
                    <el-option v-for="item in filterOriginList" :key="item.id" :label="item.addressInfo" :value="item.id">
                    </el-option>
                  </el-select>
                  <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="jumpCn">添加新发货地址</span>
                </div>
                <div class="y-bk-fff6a0" style="padding: 5px" v-else>
                  <p class="y-fl-18" style="margin: 0">未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。</p>
                </div>
              </el-form-item>
              <div v-if="filterOriginList.length <= 0 && !loading" class="y-fc-4C84FF y-c-p y-f-r y-fs-14">
                <span @click="jumpCn">开通电子面单</span>
                <span @click="getCNAccessToken" class="y-ml-10">绑定电子面单账号</span>
                <span @click="howHelpAuth('CN')" class="y-ml-10">查看教程</span>
              </div>
            </div>
            <div v-else class="tab-bottom y-fs-14 clearfix">
              <p class="y-fc-000 y-fl-18">
                您还未绑定任何菜鸟账号，请点击&lt;去绑定&gt;绑定您的菜鸟账号，或点击&lt;查看教程&gt;，按步骤进行操作。
              </p>
              <div class="y-fc-4C84FF y-c-p y-f-r">
                <span @click="getCNAccessToken">去绑定</span>
                <span @click="howHelpAuth('CN')" class="y-ml-10">查看教程</span>
              </div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-form>
</template>
<script>
import { getStore } from '@/utils/localStorage';
import { getPddMallListApi } from '@/api/customerCode.js';
import { addCustomNewNetBranchApi } from '../../../../api/waybillPrint/customPrint';
export default {
  props: ['currentType', 'userMess', 'isActive', 'saveFaceAccId'],
  model: {
    prop: 'saveFaceAccId',
    event: 'change'
  },
  data() {
    let istbRequire = (rule, value, callback) => {
      if (!value){
        callback(new Error('请输入'));
      } else {
        callback();
      }
    };
    return {
      platform: getStore('platform'),
      eleBillFormRule: {
        shop: [{ required: true, validator: istbRequire, trigger: 'change' }],
        faceId: [{ required: true, message: '请选择网点发货地址', trigger: ['blur', 'change']}]
      },
      eleBillForm: {
        shop: undefined, // 淘宝店铺
        faceId: ''
      },
      loading: true,
      activeName: 'shop',
      tbShopList: [], // 淘宝 店铺列表
      cnShopObj: {}, // 菜鸟账号列表
      filterOriginList: [], // 抖音、淘宝、拼多多电子面单模板的已有的单号来源
      originList: [], // 抖音、淘宝、拼多多电子面单模板的已有的单号来源
      aliShopObj: {}, // 1688账号列表
    }
  },
  mounted() {
    this.getPddMallListCopy();
  },
  methods: {
    handleClick(tab) {
      this.eleBillForm.shop = '';
      this.eleBillForm.faceId = '';
      if(tab.name == 'username') {
        this.cnShopObj = {};
        // 菜鸟账号列表
        let cnList = this.originList.filter(item => item.platformCode == 'CN');
        for(let i = 0; i < cnList.length; i++) {
          if(!this.cnShopObj[cnList[i].mallId]) {
            this.cnShopObj[cnList[i].mallId] = cnList[i].mallName;
          }
        }
        this.eleBillForm.shop = Object.keys(this.cnShopObj)[0];
        this.filterOriginList =  [];
        cnList.forEach(o => {
          if(o.mallId == this.eleBillForm.shop) {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.filterOriginList.push(o);
          }
        });
        if(this.filterOriginList.length) {
          this.eleBillForm.faceId = this.filterOriginList[0].id;
          this.$emit('change', this.filterOriginList[0].id);
        } else {
          this.eleBillForm.faceId = '';
          this.$emit('change', '');
        }
      } else if(tab.name == 'ali_1688') {

        this.aliShopObj = {};
        // 菜鸟账号列表
        let aliList = this.originList.filter(item => item.platformCode == 'ALI_1688');
        for(let i = 0; i < aliList.length; i++) {
          if(!this.aliShopObj[aliList[i].mallId]) {
            this.aliShopObj[aliList[i].mallId] = aliList[i].mallName;
          }
        }
        this.eleBillForm.shop = Object.keys(this.aliShopObj)[0];
        this.filterOriginList =  [];
        aliList.forEach(o => {
          if(o.mallId == this.eleBillForm.shop) {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.filterOriginList.push(o);
          }
        });
        if(this.filterOriginList.length) {
          this.eleBillForm.faceId = this.filterOriginList[0].id;
          this.$emit('change', this.filterOriginList[0].id);
        } else {
          this.eleBillForm.faceId = '';
          this.$emit('change', '');
        }
      } else {
        this.filterOriginList =  [];
        this.eleBillForm.shop = this.tbShopList.length ? this.tbShopList[0].id : '';
        // 淘宝店铺列表
        let taobaoList = this.originList.filter(item => item.platformCode != 'CN');
        taobaoList.forEach(o => {
          if(o.mallId == this.eleBillForm.shop) {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.filterOriginList.push(o);
          }
        });
        if(this.filterOriginList.length) {
          this.eleBillForm.faceId = this.filterOriginList[0].id;
          this.$emit('change', this.filterOriginList[0].id);
        } else {
          this.eleBillForm.faceId = '';
          this.$emit('change', '');
        }
      }
    },
    getPddMallListCopy() {
      this.loading = true;
      let params1 = {
        loginId: this.userMess.loginId,
        platform: 'TAOBAO'
      };
      let params2 = {
        cpCode: this.currentType, // 快递公司
        loginId: this.userMess.loginId,
        platformCode: 'CN',
        type: 'all'
      };
      let apiList = [getPddMallListApi(params1), addCustomNewNetBranchApi(params2)];
      Promise.all(apiList).then(res => {
        this.tbShopList = res[0].data || [];
        this.originList = res[1].data || [];
        if(this.activeName == 'username') {
          this.cnShopObj = {};
          // 菜鸟账号列表
          let cnList = this.originList.filter(item => item.platformCode == 'CN');
          for(let i = 0; i < cnList.length; i++) {
            if(!this.cnShopObj[cnList[i].mallId]) {
              this.cnShopObj[cnList[i].mallId] = cnList[i].mallName;
            }
          }
          this.eleBillForm.shop = Object.keys(this.cnShopObj)[0];
        } else if(this.activeName === 'ali_1688') {
          this.aliShopObj = {};
          // 菜鸟账号列表
          let aliList = this.originList.filter(item => item.platformCode == 'ALI_1688');
          for(let i = 0; i < aliList.length; i++) {
            if(!this.aliShopObj[aliList[i].mallId]) {
              this.aliShopObj[aliList[i].mallId] = aliList[i].mallName;
            }
          }
          this.eleBillForm.shop = Object.keys(this.aliShopObj)[0];
        } else {
          this.eleBillForm.shop = this.tbShopList.length ? this.tbShopList[0].id : '';
        }

        this.filterOriginList =  [];
        this.originList.forEach(o => {
          if(o.mallId == this.eleBillForm.shop) {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.filterOriginList.push(o);
          }
        });

        if(this.filterOriginList.length) {
          this.eleBillForm.faceId = this.filterOriginList[0].id;
          this.$emit('change', this.filterOriginList[0].id);
        } else {
          this.eleBillForm.faceId = '';
          this.$emit('change', '');
        }
        this.loading = false;
      }).catch(err => {
        console.log(err)
        this.$message.error('获取面单账号失败');
        this.loading = false;
      })
    },
    // 选择店铺
    changeShop(){
      // 移除表单的校验效果
      this.$refs['eleBillForm'].clearValidate();
      this.filterOriginList =  [];
      this.originList.forEach(o => {
        if(o.mallId == this.eleBillForm.shop) {
          o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
          this.filterOriginList.push(o);
        }
      });
      if(this.filterOriginList.length) {
        this.eleBillForm.faceId = this.filterOriginList[0].id;
        this.$emit('change', this.eleBillForm.faceId);
      } else {
        this.eleBillForm.faceId = '';
        this.$emit('change', '');
      }
    },
    changeAddress(val) {
      this.$emit('change', val);
    },
    // 店铺授权
    storeAuthorization(plat) {
      // 淘宝WEB授权
      const {loginId} = this.$store.state.user||'';
      const baseOrginUrl = location.origin;
      // 淘宝WEB授权
      if(plat === 'TAOBAO') {
        /**
         * @params
         * state 后台授权完成跳转
         *    9:  /systemSetting/electronicBillManagement
         *    19:  /systemSetting/waybillTemplate
         */
        window.open('https://oauth.taobao.com/authorize?response_type=code&client_id=32528785&redirect_uri='+baseOrginUrl+'/tb-api/taobao/mini/api/oauth/callback&state=9-'+this.currentType+'-TB-'+loginId, '_blank');
      }
      if(plat === 'ALI_1688') {
        window.open('https://oauth.taobao.com/authorize?response_type=code&client_id=33582806&redirect_uri='+baseOrginUrl+'/ali-api/alibaba/api/oauth/electronic/callback&state=9-' + this.currentType +'-1688-'+loginId, '_blank');
      }
    },
    // 获取菜鸟accesstoken
    getCNAccessToken() {
      if(this.platform === 'ALI_1688') {
        window.open(`https://lcp.cloud.cainiao.com/permission/isv/grantpage.do?isvAppKey=941220&ext=${this.currentType}&redirectUrl=${window.location.origin}${window.location.pathname}`, '_blank');
      } else {
        window.open(`https://lcp.cloud.cainiao.com/permission/isv/grantpage.do?isvAppKey=941220&ext=${this.currentType}&redirectUrl=${window.location.origin}${window.location.pathname}`, '_self');
      }
    },
    jumpTb() {
      window.open('https://waybill.wuliu.taobao.com/myServiceProviders.htm?spm=a1z3x.7846489.0.0.5fdb41bfZa6Lwc', '_blank')
    },
    jumpCn() {
      window.open('https://dayin.cainiao.com/miandan/subscribe/subscribe.htm?spm=a2dd9.12846551.0.0.11c25cadJTQtOZ', '_blank')
    },
    // 弹出帮助窗口
    howHelpAuth(type){
      const { href } = this.$router.resolve({
        name: `authShopHelp`
      });
      window.open(`${href}?type=${type}`, '_blank');
    },
  },
  watch: {
    isActive(val) {
      if(!!val) {
        this.getPddMallListCopy();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-company-box {
  width: 35px;
  height: 35px;
  margin-right: 10px;
  vertical-align: middle;
}
.step4CnCom {
  /deep/ .el-tabs__item {
    height: 46px;
    line-height: 46px;
  }
  /deep/ .el-select {
    flex: 1;
  }
  .tab-header {
    display: flex;
    padding: 16px 75px 32px;
    justify-content: center;
    .left-c {
      display: flex;
      .icon-width36 {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }
    }
    .right-c {
      margin-left: 14px;
      color: #f32f52;
      cursor: pointer;
    }
  }
  .tab-bottom {
    padding: 0 40px;
  }
}
</style>
